import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEyeconxStore } from '../store/eyeconxStore';
import { isClinicFeatureEnabled } from '../modules/clinicFeatures/clinicFeatureUtils';
import Loading from '../components/common/Loading';

/**
 * Renders children only when the clinic feature flag is enabled.
 * Redirects to dashboard when the feature is off (after features have loaded).
 */
const ClinicFeatureRoute = ({ featureKey, children }) => {
    const clinicFeatures = useEyeconxStore((state) => state.clinicFeatures);
    const clinicFeaturesLoaded = useEyeconxStore((state) => state.clinicFeaturesLoaded);

    if (!clinicFeaturesLoaded) {
        return (
            <div className="d-flex align-items-center justify-content-center min-vh-100">
                <Loading />
            </div>
        );
    }

    if (!isClinicFeatureEnabled(featureKey, clinicFeatures, clinicFeaturesLoaded)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ClinicFeatureRoute;
